
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";

import { LeafletViewer    } from "@/components/leaflet/leaflet.viewer";

export class ResetLeaflet extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private readonly _controller : LeafletViewer = null;

  /** standard constructor */
  constructor(controller : LeafletViewer) {
    super({
      key:   ActionType.LEAFLET_RESET,
      type:  ActionType.LEAFLET_RESET,
      label: 'Reset Map View',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): LeafletViewer {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.reset();

    return true;
  }
}
